export default __webpack_public_path__ + "static/media/quadro.e57162ab.jpg";